<div class="custom-snackbar" role="status" aria-label="Snackbar notification">
  <span class="snackbar-message" matSnackBarLabel>
    {{ data }}
  </span>
  <span class="snackbar-close" (click)="closeSnackBar()" aria-label="Close">
    ✖
  </span>
  <div class="snackbar-progress"></div>
</div>
